import React, { useContext } from 'react';
import { Profile } from '../../../Types';
import { StateContext } from '../../../GlobalStateStore';
import OMProxyWidget from './OMProxyWidget';
import TMProxyWidget from './TMProxyWidget';

interface ProxyWidgetProps {
  userProfile: Profile;
}

const ProxyWidget: React.FC<ProxyWidgetProps> = ({ userProfile }) => {
  const { isOm, userID } = useContext(StateContext).state.inspireOptions.data;

  return isOm && userID == userProfile.user.userID ? (
    <OMProxyWidget userProfile={userProfile} />
  ) : (
    <TMProxyWidget userProfile={userProfile} />
  );
};

export default ProxyWidget;
